module.exports = __webpack_public_path__ + "2f1ab70c1c1491dfeb9b2b8de63e83a8.png";


//////////////////
// WEBPACK FOOTER
// ./components/home/sample/zip-reports-logo.png
// module id = 581
// module chunks = 0